import { meal_filters } from '@app/utilities/constants';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger
} from '@components/ui/dropdown-menu';
import { Check, Filter } from 'lucide-react';
import React from 'react';

const FilterDropdown = ({ handleFilterChange, filters }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="bg-white size-8 border border-[#E7E7E9] flex items-center justify-center rounded-[10px] cursor-pointer">
          <Filter size={20} color="#5B5B6C" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        sideOffset={10}
        align="end"
        className="min-w-[231px] w-full bg-white !rounded-[12px] !shadow-[0px_0px_4px_2px_#0000001A] border-0 p-2 ring-0 hover:border-0 hover:ring-0 space-y-2"
      >
        {meal_filters.map((filter, idx) => (
          <DropdownMenuSub>
            <DropdownMenuSubTrigger
              className="p-2  data-[highlighted]:bg-[#549a9a] outline-none data-[highlighted]:text-white transition-all duration-500 ease-in-out cursor-pointer
  focus:outline-none
  focus:ring-0
  ring-0"
              key={idx}
            >
              <div>{filter.label}</div>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent
                avoidCollisions={true}
                sideOffset={10}
                className="flex flex-col gap-2 bg-white ring-0"
              >
                {filter?.children?.map((item, id) => (
                  <DropdownMenuItem
                    onClick={() => {
                      if (filter.type === 'availability') {
                        handleFilterChange('hasTags', item.value);
                        return;
                      }
                      if (filter.type === 'field') {
                        handleFilterChange('field', item.value);
                        return;
                      }
                      if (filter.type === 'sort') {
                        handleFilterChange('sortBy', item.value);
                        return;
                      }
                      if (filter.type === 'status') {
                        handleFilterChange('shown', item.value);
                        return;
                      }
                      if (filter.type === 'type') {
                        handleFilterChange('type', item.value);
                        return;
                      }
                    }}
                    key={id}
                    className="data-[highlighted]:bg-[#549a9a] outline-none transition-all duration-500 ease-in-out cursor-pointer flex items-center
  focus:outline-none
  focus:ring-0
  ring-0
                  data-[highlighted]:text-white"
                  >
                    {item.label}{' '}
                    {filter.type === 'availability' &&
                      filters?.hasTags === item.value && <Check size={20} />}
                    {filter.type === 'field' && filters?.field === item.value && (
                      <Check size={20} />
                    )}
                    {filter.type === 'sort' && filters?.sortBy === item.value && (
                      <Check size={20} />
                    )}
                    {filter.type === 'status' && filters?.shown === item.value && (
                      <Check size={20} />
                    )}
                    {filter.type === 'type' && filters?.type === item.value && (
                      <Check size={20} />
                    )}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default FilterDropdown;
